import * as React from 'react';
import { List, Datagrid, TextField, DateField, ReferenceField, CreateButton, ExportButton, TopToolbar } from 'react-admin';

const ListActions = () => (
  <TopToolbar>
      <CreateButton/>
      <ExportButton maxResults={999999999}/>
  </TopToolbar>
);

export const PresetList = (props: any) => (
  <List actions={<ListActions />} {...props}>
    <Datagrid bulkActionButtons={null} rowClick="edit">
      <ReferenceField source="sectorId" reference="sectors">
        <TextField source="name" />
      </ReferenceField>
      <DateField source="createdAt" />
      <DateField source="updatedAt" />
    </Datagrid>
  </List>
);
